import React from "react";
import { formatImageUrl } from "@/lib/general";
import LazyLoad from "@tripbuilder/image/LazyLoad";

interface ProcessedImage {
  caption: string;
  lowRes: string;
  highRes: string;
}

interface CarouselProps {
  images: ProcessedImage[];
  openModal: () => void;
}

const Carousel: React.FC<CarouselProps> = ({ images, openModal }) => {
  return (
    <div className="relative w-full flex flex-col items-center justify-start">
      <div
        id="expPhotoCarousel"
        className="w-full h-64 flex items-center space-x-2 overflow-x-auto rounded-md whitespace-nowrap scroll-smooth no-scrollbar"
      >
        {images.map((imageObject, index) => (
          <LazyLoad
            key={index}
            src={formatImageUrl(imageObject.highRes, "medium")}
            lowResSrc={formatImageUrl(imageObject.lowRes, "low")}
            alt={imageObject.caption}
            className="h-64 w-64 flex-shrink-0 rounded-md"
            objectFit="cover"
          />
        ))}
      </div>
      {/* View all images button */}
      <button
        onClick={openModal}
        className="absolute bottom-2 right-2 bg-white bg-opacity-90 hover:bg-opacity-100 text-gray-800 p-2 rounded-lg text-xs font-medium transition-all duration-200 shadow-md"
      >
        View All
      </button>
    </div>
  );
};

export default Carousel;
